import { Dimmer, Loader } from 'semantic-ui-react';
const Loading = ({ children, text }) => (
  <Dimmer page active inverted>
    <Loader inline="centered">{text || children}</Loader>
  </Dimmer>
);
export default Loading;
